
const it = {
  main: {
    hello: 'Hello World!',
  },

  navButton: {
    xxregistryClient: 'Crea Cliente',

  },
  button: {
    save: 'Salva',
    reset: 'Annulla',
    upload: 'Scegli file',
    close: 'Chiudi',
    generate: 'Genera',
    download: 'Scarica',
    delete: 'Elimina',
    gotoToday: 'Vai a oggi',
    manage: 'Gestisci',
    new: 'Nuovo',
    goBack: 'Indietro',
    cancel: 'Annulla',
    confirm: 'Conferma',
    invite: 'Invita',
    clear: 'Pulisci',
    crop: 'Ritaglia',
    change: 'Cambia',
    update: 'Aggiorna',
    edit: 'Modifica',
    add: 'Aggiungi',
    addNew: 'Aggiungi Nuovo',
    search: 'Cerca',
    next: 'Avanti',
    send: 'Invia',
    view: 'Visualizza',
    clone: 'Duplica',
    print: 'Stampa',
  },
  actions: {
    title: 'Azioni',
    VIEW: 'Visualizza',
    CREATE: 'Crea',
    EDIT: 'Modifica',
    DELETE: 'Elimina',
    LIST: 'Elenco',
    EXPORT: 'Esporta',
    DOWNLOAD: 'Scarica',
    DISABLE: 'Disabilita',
    ENABLE: 'Abilita',
    SETPREFERRED: 'Preferito',
    SETDEFAULT: 'Predefinito',
    ARCHIVE: 'Archivia',
    RESTORE: 'Ripristina',
    ACTIVITY: 'Attività',
    MANAGE: 'Gestisci',
    CONNECT: 'Collega',
    INVITE: 'Invita',
    CLONE: 'Duplica',
    SEND: 'Invia',
    COMPLETE: 'Completa',
    CANCEL: 'Annulla',
    DRAFT: 'Bozza',
  },
  editor: {
    insertVideo: 'Inserisci Video',
    videoUrl: 'URL del video',
    imageUrl: 'URL dell\'immagine',
    orUpload: 'o carica',
  },

  generic: {
    appUpdate:
      "Nuova versione disponibile. Stiamo per aggiornare la tua pagina per recuperare l'ultima versione {version}.",
    version: 'Versione {version}',
    versionMin: 'v.{version}',
    detail: 'Dettaglio',
    clickToZoom: 'Seleziona per ingrandire',
    loading: 'Caricamento...',
    showInfo: 'Mostra informazioni aggiuntive',
    otherwise: 'oppure',
    search: 'Cerca',
    requiredField: '(*) Valore richiesto',
    emailMandatory: 'Email obbligatoria',
    emailFormat: 'E-mail non valida',
    insertData: 'Inserisci i dati',
    select: 'Seleziona un valore',
    record: 'Record',
    all: 'Tutti',
    vat: {
      0: 'Non soggetto (0%)',
      4: '4%',
      10: '10%',
      22: '22%',
    },
    timeFrame: 'Periodo',
    from: 'Dal',
    to: 'Al',
    ALL: 'Tutti',
    ALLf: 'Tutte',
    CREATE: 'Crea',
    UPDATE: 'Modifica',
    EDIT: 'Modifica',
    VIEW: 'Visualizza',
    ACTIVITY: 'Attività',
    CONNECT: 'Collega',
    amount: 'Importo',
    percentage: 'Percentuale',
    unitPrice: 'Prezzo Unitario',
    or: 'oppure',
    noData: 'Nessun dato',
    noRecordFound: 'Nessun record trovato',
    moreRecordAvailable: 'Altri record disponibili.',
    refineSearch: 'Raffina la ricerca',
    delete: 'Elimina',
    deleteSubtitle: 'Sei sicuro di voler eliminare questo elemento?',
    externalStatus: {
      label: 'Stato',
      NOTDEFINED: 'Non definito',
      DRAFT: 'Bozza',
      INPROGRESS: 'In Corso',
      PENDING: 'In Attesa',
      SIGNED: 'Firmato',
      CLOSED: 'Chiuso',
      CANCELLED: 'Annullato',
      LOST: 'Perso',
      ALL: 'Tutti',
    },
    status: {
      label: 'Stato',
      ACTIVE: 'Attivo',
      DISABLED: 'Disabilitato',
      ARCHIVED: 'Archiviato',
      DELETED: 'Eliminato',
      PENDING: 'In attesa',
      ALL: 'Tutti',
    },
    measureMinMaxHint: 'Min: {min} mm, Max: {max} mm',
    amountMinMaxHint: 'Min: {min}, Max: {max}',
    multimedia: 'Multimedia',
    thumbnail: 'Miniatura/Logo',
    image: 'Immagine',
    image2: 'Immagine 2',
    image3: 'Immagine per documenti',
    description: 'Descrizione ',
  },

  uploadFile: {
    label: 'Carica file',
    noFileUploaded: 'Nessun file caricato',
    uploadFileDescription:
      "Seleziona il tipo per poter caricare il file. Se selezioni 'Altro' devi inserire una descrizione",
    placeholder: 'Seleziona uno o più file da caricare o trascinali qui',
    description: 'Descrizione File',
    modelOwnerAttachmentType: 'Tipo di File',
    descriptionPlaceholder: 'Contenuto del file',
    creationDate: 'Data: {creationDate} {creationTime}',
    noFiles: 'Nessun file',
    error: 'Errore nel caricamento del file',
    errorFileSize: 'Dimensione massima consentita {maxSize} MB per file, il file caricato è di {fileSize}',
  },
  cropFile: {
    label: 'Immagine',
    cropImageTitle: 'Seleziona Immagine',
    cropImageSubTitle: "Seleziona l'immagine e adattala al formato richiesto, poi clicca su 'Ritaglia'",
  },

  dateRange: {
    TODAY: 'Oggi',
    YESTERDAY: 'Ieri',
    LAST7DAYS: 'Ultimi 7 giorni',
    LAST30DAYS: 'Ultimi 30 giorni',
    CURRENTWEEK: 'Settimana in corso',
    PREVWEEK: 'Settimana scorsa',
    THISMONTH: 'Mese in corso',
    PREVIOUSMONTH: 'Mese Precedente',
    LAST3MONTHS: 'Ultimi 3 mesi',
    NEXTMONTH: 'Mese Successivo',
    CUSTOM: 'Personalizzato',
    ALLDATE: 'Tutto',
  },
  export: {
    exportFormat: {
      XLSX: 'Excel 2007+ XML (XLSX)',
      XLS: 'Excel 97-2004 (XLS)',
      CSV: 'Comma Separated Values (CSV)',
      RTF: 'Rich Text Format (RTF)',
      PDF: 'PDF',
    },
  },
  settingsTab: {
    ACCOUNT: 'Utente',
    SECURITY: 'Sicurezza',
    COMPANY: 'Azienda',
    NOTIFICATION: 'Notifiche',
    ADVANCESETTING: 'Impostazioni Avanzate',
  },
  notAuthorized: {
    actionText: 'Torna alla Home',
    text: 'Qualcosa è andato storto!!! Non sei autorizzato a visualizzare questa pagina',
    title: 'Non autorizzato',
  },
  table: {
    noData: 'Nessun dato',
    noResults: 'Nessun risultato',
    itemsPerPage: 'Elementi per pagina',
    page: 'Pagina',
  },
  materialType: {
    label: 'Tipo Materiale',
    enabledMaterialType: 'Tipo Materiale Abilitato',
    WOOD: 'Legno',
    ALUMINIUM: 'Alluminio',
    PVC: 'PVC',
    ALL: 'Tutti',
    NONE: 'Nessuno'
  },
  entryType: {
    label: 'Tipo Parametro',
    SINGLEOPTION: 'Opzione Singola',
    MULTIOPTION: 'Opzione Multipla',
    SELECTOR: 'Selettore',
    CHECKBOX: 'Checkbox',
    NONE: 'Nessuna',
  },
  yesNoOptional: {
    YES: 'Si',
    NO: 'No',
    OPTIONAL: 'Facoltativo',
    MANDATORY: 'Obbligatorio'
  },
  dashboard: {
    welcomeTitle: 'Benvenuto {name}!',
    welcomeSubTitle: 'Ecco un riepilogo delle ultime attività.',
    userTypeOn: '{profile} presso {company}',
  }
}
export default it
